import axios from 'axios';
import { req } from './axiosFun';

/**
 * 景点管理
 **/
// 获取景点列表
export const campList = (params) => { return axios.get("/customer/listLineHuanghang") };
export const campListSave  = (params) => { return req("post", "/customer/addLineHuanghang", params) };
export const campListDel  = (params) => { return req("post", "/customer/deleteLineHuanghang", params) };






// WEBPACK FOOTER //
// ./src/api/campsMG7.js